<template>
  <div>
    <SentenceStyle
      ref="SentenceTextArea"
      :list-word-data="funnyStr"
    ></SentenceStyle>
    <!-- mode="ease" -->
    <div class="space"></div>
    <SimpleKeyboard
      ref="Keyboard"
      @onChange="onChange"
      @onKeyPress="onKeyPress"
      :input="input"
      :show-gesture="true"
      :next-input="nextInput"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "../../SimpleKeyboard";
import SentenceStyle from "../../StyleText/SentenceStyle";
export default {
  name: "LevelStep",
  components: {
    SimpleKeyboard,
    SentenceStyle,
  },
  data: () => ({
    input: "",
    nextInput: "",
    funnyStr:
      "Hello World Python C++ Words Excel PPT Javascript Letter Funny Shift Ctrl;",
  }),
  created() {
    this.$nextTick(() => {
      this.nextInput = this.$refs.SentenceTextArea.nextKey();
    });
  },
  mounted() {
    this.$refs.Keyboard.compare = (btn) => {
      console.log("当前的", btn);

      if (btn === false) {
        return true;
      }
      this.$refs.SentenceTextArea.handlerWord(btn);
      this.nextInput = this.$refs.SentenceTextArea.nextKey();
      var ch = this.$refs.SentenceTextArea.nextWord();
      console.log(ch, "ch");
      return ch === btn;
    };
  },
  methods: {
    onChange(input) {
      this.input = input;
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
    onInputChange(input) {
      this.input = input.target.value;
    },
  },
};
</script>

<style lang="less" scoped></style>
